import React, { Component } from 'react';

class About extends Component {
    render() {
        return (
            <section className="instruction__page mb-5 pb-5">
                <div className="container">
                    <div className="row pt-5 mb-3">
                        <div className="col-12">
                            <h2>Giới thiệu</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="content-page">
                                <p><strong><span style={{ color: '#e11f25' }}>
                                    <span style={{ fontSize: '15pt' }}>ENDA-</span></span>
                                    <span style={{ color: '#e2e01a', fontSize: '15pt' }}>Ki</span>
                                    <span style={{ fontSize: '15pt' }}>suhi</span>
                                </strong> – mang đến các giải pháp thời trang dựa trên tinh thần đơn giản, phóng khoáng, hiện đại chứa đựng sự cổ điển đầy tinh tế.&nbsp;<strong>
                                        <span style={{ color: '#e11f25' }}><span style={{ fontSize: '15pt' }}>ENDA-</span>
                                        </span></strong><span style={{ fontSize: '15pt' }}><strong>
                                            <span style={{ color: '#e2e000' }}>Ki</span>suhi</strong>
                                    </span>luôn quan niệm rằng Sự tao nhã trong thời trang không phải là việc bạn được người khác chú ý, mà là cách họ nhớ đến bạn và là cảm giác khi bạn khoác lên bộ cánh bạn yêu thích.</p><p><strong>Slogan:&nbsp;
                                                <span style={{ color: '#e11f25' }}><span style={{ fontSize: '15pt' }}>ENDA </span></span>
                                        <span style={{ fontSize: '15pt' }}>- </span></strong><span style={{ fontSize: '14px' }}>Eva &amp; Double Attractions.</span>
                                </p><p><strong>Tầm nhìn:</strong>&nbsp;Trở thành nơi lựa chọn hàng đầu của khách hàng thời trang.</p>
                                <p><strong>Triết lý kinh doanh:&nbsp;</strong><strong><span style={{ color: '#e11f25' }}>
                                    <span style={{ fontSize: '15pt' }}>ENDA </span></span></strong>đề cao giá trị của sự trung thực,&nbsp;<strong>
                                        <span style={{ color: '#e11f25' }}><span style={{ fontSize: '15pt' }}>ENDA </span>
                                        </span></strong>kinh doanh bằng sự tử tế.</p><p><strong>Giá trị:&nbsp;<span style={{ color: '#e11f25' }}>
                                            <span style={{ fontSize: '15pt' }}>ENDA </span></span>
                                        </strong>luôn cố gắng mang đến các giá trị tốt nhất, mang đến sự hài lòng cho khách hàng. Các sản phẩm của Kisuhi sẽ cùng sánh bước để quý khách cảm thấy tự tin, cuốn hút và cuộc sống tươi đẹp hơn.</p><p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
